/**
 * MarketingHero — `/`
 *
 * Single-CTA landing surface. The CTA navigates to `/rehearsal`, where
 * an anonymous session is created end-to-end (no signup required).
 */

import { Link } from "react-router-dom";

export default function MarketingHero(): React.ReactElement {
  return (
    <section
      data-testid="page-marketing-hero"
      style={{
        padding: "3rem 1.5rem",
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        gap: "1rem",
        maxWidth: "44rem",
      }}
    >
      <h1 className="font-sohne-display" style={{ margin: 0, fontSize: "2.25rem", lineHeight: 1.1 }}>
        animachord — score-and-stage for AI agents
      </h1>
      <p
        className="text-paper-cream-dim leading-rehearsal"
        style={{ margin: 0, fontSize: "1rem", maxWidth: "36rem" }}
      >
        Score voices, stage takes, and watch your ensemble play live. No
        signup needed to take the stage.
      </p>
      <Link
        to="/rehearsal"
        data-testid="marketing-hero-cta"
        className="font-plex-mono"
        style={{
          background: "var(--brass-cue)",
          color: "var(--score-ink)",
          padding: "0.6rem 1.1rem",
          borderRadius: "var(--radius)",
          textDecoration: "none",
          fontSize: "0.875rem",
        }}
      >
        Try Rehearsal
      </Link>
    </section>
  );
}
